import React, { CSSProperties } from 'react'

import { colors } from '@lmc/common/constants'
import Icon from '../Icon/index'
import IconType from '../Icon/iconTypes'

const styles = {
  logo: {
    marginLeft: 20,
    width: '26px',
    height: '24px',
    cursor: 'pointer',
  },
  logoText: {
    marginRight: 50,
    marginLeft: 10,
    fill: colors.white,
    width: '87px',
    height: '15px',
    cursor: 'pointer',
  },
}

export interface LogoProps {
  type: 'light' | 'dark'
  style?: CSSProperties
}

export const Logo: React.FC<LogoProps> = ({ type }) => {
  const color = type === 'light' ? colors.white : colors.darkpurple
  styles.logoText = { ...styles.logoText, fill: color }

  return (
    <>
      <Icon customIcon={IconType.NewLogo} style={styles.logo} />
      <Icon customIcon={IconType.NewLogoText} style={styles.logoText} />
    </>
  )
}
